// src/services/api.js
import axios from 'axios';

const API_URL = 'https://murima.julesferry-ga.com/api/ajax';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  withCredentials: true,
});

// Intercepteur pour s'assurer que les données sont au bon format
api.interceptors.request.use(
  (config) => {
    // Si c'est une requête POST et que les données sont un objet
    if (config.method === 'post' && config.data && typeof config.data === 'object') {
      // Si ce n'est pas déjà un URLSearchParams ou FormData
      if (!(config.data instanceof URLSearchParams) && !(config.data instanceof FormData)) {
        const formData = new URLSearchParams();
        Object.keys(config.data).forEach(key => {
          // Convertir en string pour éviter les problèmes
          formData.append(key, String(config.data[key]));
        });
        config.data = formData;
      }
    }
    
    console.log('📡 API Request:', {
      method: config.method.toUpperCase(),
      url: config.url,
      data: config.data?.toString() || config.data
    });
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Intercepteur pour les réponses
api.interceptors.response.use(
  (response) => {
    console.log('✅ API Response:', response.config.url, response.data);
    return response;
  },
  (error) => {
    if (error.response) {
      console.error('❌ API Error:', error.response.status, error.response.data);
    }
    return Promise.reject(error);
  }
);

export default api;